import React, {Component, useState} from 'react';
import { Button, Container, Row, Col, FormControl, FormLabel, Alert } from 'react-bootstrap';
import ItemService from "./services/item.service";
import SupplierDataService from "./services/supplier.service";
import UOMDataService from "./services/uom.service";
import { Navigate } from 'react-router-dom';
import { IoIosArrowBack } from "react-icons/io";
import MultiSelectControl from "./MultiSelectControl";
import { PageHeader, NewHeader } from './AuxiliaryFunctions';
import TopAndSideBar from './TopAndSideBar';

var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

class NewItem extends Component {  

  constructor(props) {
    super(props);
    this.onChangeItemPartNumber = this.onChangeItemPartNumber.bind(this);
    this.onChangeItemDescription = this.onChangeItemDescription.bind(this);
    this.onChangeItemPrice = this.onChangeItemPrice.bind(this);
    this.onChangeItemCost = this.onChangeItemCost.bind(this);
    this.onChangeUOM = this.onChangeUOM.bind(this);
    this.saveItem = this.saveItem.bind(this);
    this.retrieveItems = this.retrieveItems.bind(this);
    this.retrieveSuppliers = this.retrieveSuppliers.bind(this);
    this.retrieveUOMs = this.retrieveUOMs.bind(this);
    this.refreshList = this.refreshList.bind(this);    
    this.handleValidations = this.handleValidations.bind(this);
    this.handleSelect = this.handleSelect.bind(this);

    this.state = {
      id: null,
      itempartnumber: "",
      itemdescription: "",
      itemprice: "",
      itemcost: "",
      itemsupplier: "",
      submitted: false,
      items: [],
      suppliers: [],
      uoms: [],
      selectedsuppliers: [],
      currentItem: null,
      currentIndex: -1,  
      showerror: false,
      errmessage:'',   
      showsuccess: false,
      succmessage: ''
    };
  }

  componentDidMount () {
    this.retrieveSuppliers();
    this.retrieveUOMs();
  }
  
  retrieveSuppliers() {
    SupplierDataService.getAll()
      .then(response => {
        this.setState({
            suppliers: response.data
        });
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  }

  retrieveUOMs() {
    UOMDataService.getAll()
      .then(response => {
        this.setState({
            uoms: response.data
        });
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  }

  goToItemsList() {
    window.location.assign('/items');
  }

  handleValidations() {
    if (this.state.itemdescription.length==0 || this.state.itemcost.length==0) {
      this.setState({errmessage:'Fields can not be empty.'})
      this.setState({showerror:true})
      return;
    }
    if (this.state.itemprice.length>0) {
      if (this.state.itemcost >= this.state.itemprice) {
        this.setState({errmessage:'Item price must be greater than item cost.'})
        this.setState({showerror:true})      
        return;
      }
      this.saveItem();
    }
    else {
      this.saveItem();
    }
  } 

  retrieveItems() {
    ItemService.getAll()
      .then(response => {
        this.setState({
            items: response.data
        });
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  }

  refreshList() {
    this.retrieveItems();
    this.setState({
        currentPatient: null,
        currentIndex: -1
    });
  }

  onChangeItemPartNumber(e) {
    this.setState({
      itempartnumber: e.target.value
    });
  }

  onChangeItemDescription(e) {
    this.setState({
      itemdescription: e.target.value
    });
  }

  onChangeItemPrice(e) {
    this.setState({
      itemprice: e.target.value
    });
  }  

  onChangeItemCost(e) {
    this.setState({
      itemcost: e.target.value
    });
  }    

  onChangeUOM(e) {
    this.setState({
      primaryuomId: e.target.value
    });
  }   

  saveItem() {
    var data = {
      itemdescription: this.state.itemdescription,
      itempartnumber: this.state.itempartnumber,
      standardsellingunitprice: this.state.itemprice,
      primaryuomId: this.state.primaryuomId,
      itemsupplier: this.state.selectedsuppliers,
      standardpurchaseunitprice: this.state.itemcost     
    };

    ItemService.create(data)
      .then(response => {
        this.setState({
          // id: response.data.id,
          itemdescription: response.data.itemdescription,
          itempartnumber: response.data.itempartnumber,
          itemprice: response.data.itemprice,
          itemsupplier: response.data.itemsupplier,

          submitted: true          
        });
        this.setState({errmessage:''});
        this.setState({showerror:false});
        this.setState({succmessage:'Item has been created. Redirecting to item list...'});
        this.setState({showsuccess:true});           
        this.refreshList();
        console.log(response.data.id);
      })
      .catch(e => {
        this.setState({errmessage:e.response?e.response.data.message:e.message})       
        this.setState({showerror:true})
        this.setState({succmessage:''})
        this.setState({showsuccess:false}) 
      });
  }

  // This function is passed as props to a child component (functional component)
  // The function runs on the child component and the state of the parent selectedsuppliers gets updated
  // when the parent is a functional component: https://daveceddia.com/useeffect-hook-examples/#run-useeffect-on-state-change
  // when the parent is a class component: https://bobbyhadz.com/blog/react-pass-data-from-child-to-parent
  handleSelect = (selValue) => {
    this.setState({selectedsuppliers: selValue});
  }

  render() {
    return (
      <>
      <div style={{display:"flex", flexDirection:"column",width:"100%"}}>
        <TopAndSideBar />
        <NewHeader headerTitle={"New Item"}/>  
        <Container>
          <Row className='mb-2'>
            <Col className='col-md-3' sm={8}>
              <FormLabel className='mb-2'>Item Part Number:</FormLabel>       
              <FormControl style={{maxWidth:"300px"}} type="text" name="itempartnumber" id="itempartnumber" onChange={this.onChangeItemPartNumber}></FormControl>
            </Col>

            <Col className='col-md-3' sm={8}>
              <FormLabel className='mb-2'>Item Description:</FormLabel>       
              <FormControl style={{maxWidth:"300px"}} type="text" name="itemdescription" id="itemdescription" onChange={this.onChangeItemDescription}></FormControl>
            </Col>          

            <Col className='col-md-3' sm={8}>
              <FormLabel className='mb-2'>Item Price:</FormLabel>       
              <FormControl style={{maxWidth:"300px"}} type="number" name="itemprice" id="itemprice" onChange={this.onChangeItemPrice}></FormControl>
            </Col> 

            <Col className='col-md-3' sm={8}>
              <FormLabel className='mb-2'>Item Cost:</FormLabel>       
              <FormControl style={{maxWidth:"300px"}} type="number" name="itemcost" id="itemcost" onChange={this.onChangeItemCost}></FormControl>
            </Col>            

            <Col className='col-md-3' sm={8}>
              <FormLabel className='mb-2'>Primary UOM:</FormLabel>       
              <FormControl as='select' onChange={this.onChangeUOM}>
                <option disabled selected> {/**disabled={true} does not work!*/}
                  {"Select"}
                </option>
                {this.state.uoms.map((uom) => {
                  return (
                    <>
                    <option key={uom.unitofmeasureabbrev} value={uom.id}>
                      {uom.unitofmeasureabbrev}
                    </option>
                    </>
                  );
                })}
              </FormControl>
              <FormLabel className='mb-2' style={{fontSize:"12px"}}>Note: Primary UOM can not be changed after the item is created.</FormLabel>       
            </Col>  

            <Col className='col-md-3' sm={8}>
              <FormLabel className='mb-2'>Default Back Finish Cost:</FormLabel>       
              <FormControl style={{maxWidth:"300px"}} type="number" name="defaultbackfinishcost" id="defaultbackfinishcost" onChange={this.onChangeItemCost}></FormControl>
            </Col>  
          </Row>
          <hr/>
          <Row>
            <FormLabel className='mb-2'>Select the autorized suppliers for this item:</FormLabel>       
            {/*<MultiSelectControl response={this.state.suppliers} descField="suppliername" idField="id" selValue={this.handleSelect}></MultiSelectControl>*/}
            <MultiSelectControl loadmode={true} key={"s"} initialselectedids={[]} alloptions={this.state.suppliers} descField="suppliername" idField="id" selValue={this.handleSelect}></MultiSelectControl>
          </Row>
          {this.state.showerror && (
            <Alert variant="danger" onClose={() => this.setState({showerror:false})} dismissible>
              <Alert.Heading>Error</Alert.Heading>
              <p>{this.state.errmessage}</p>
            </Alert>      
          )}
          {this.state.showsuccess && (
            <Alert variant="success" onClose={() => this.setState({showsuccess:false})} dismissible>
              <Alert.Heading>Done</Alert.Heading>
              <p>{this.state.succmessage}</p>
            </Alert>      
          )} 
          <hr/>
          <Row className='mb-2'>
            <Col className='col-md-3'>
              <Button id='saveItem' onClick={this.handleValidations}>Save Item</Button>            
              <Button className='m-2' id='backToUsersList' onClick={this.goToItemsList}><IoIosArrowBack/></Button>            
            </Col>
          </Row>      
          { this.state.submitted ? (<Navigate push to="/items"/>) : null }                                     
        </Container>            
      </div>
      </>
    )      
  }
}

export default NewItem;